import api from 'services/api';
import { IntegrationKeyProps } from './integration-key-service';

export type IntegrationPreferenceProps = {
  uuid?: string;
  emailRequired?: boolean | string;
  keys?: IntegrationKeyProps[] | any;
  requiresSecondAuth?: boolean | string;
  integrationUuid: string;
};

const findAllIntegrationPreferences = async () => {
  const response = await api.get<IntegrationPreferenceProps[]>('/apiv1/preferences/');
  return response?.data;
};

const findIntegrationPreferenceById = async (uuid: string | undefined) => {
  const response = await api.get<IntegrationPreferenceProps>(`/apiv1/preference/${uuid}/`);
  return response?.data;
};

const createIntegrationPreference = async (
  newIntegrationPreference: IntegrationPreferenceProps
) => {
  const response = await api.post<IntegrationPreferenceProps>(
    '/apiv1/preference/',
    newIntegrationPreference
  );
  return response?.data;
};

const updateIntegrationPreference = async (
  uuid: string | undefined,
  updatedIntegrationPreference: IntegrationPreferenceProps
) => {
  const response = await api.put<IntegrationPreferenceProps>(
    `/apiv1/preference/${uuid}/`,
    updatedIntegrationPreference
  );
  return response?.data;
};

const deleteIntegrationPreferenceById = async (uuid: string | undefined) => {
  const response = await api.delete<IntegrationPreferenceProps>(`/apiv1/preference/${uuid}/`);
  return response?.data;
};

const IntegrationPreferenceService = {
  findAllIntegrationPreferences,
  findIntegrationPreferenceById,
  createIntegrationPreference,
  updateIntegrationPreference,
  deleteIntegrationPreferenceById
};

export default IntegrationPreferenceService;
